// extracted by mini-css-extract-plugin
export default {"root":"StudentsTable_root__LAGtJ","operation":"StudentsTable_operation__ktsB2","column":"StudentsTable_column__1h1OQ"};